import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { SortDirection } from '@steelbuy/api-integration';
import { BROWSE_LISTING_KEY } from '@steelbuy/data-access';
import { MaterialType } from '@steelbuy/ts-shared';
import { useVendor } from '@steelbuy/vendor';
import { CheckoutContextProvider } from '../../components/checkout/CheckoutContext';
import {
    DashboardFormContextProvider,
    getDefaultDashboardFormData,
} from '../../components/dashboard-listings.tsx/DashboardFormContext';
import { SearchResultsContextProvider } from '../../components/listing-search/SearchResultsContext';
import { useScrollPositionContext } from '../../components/scroll-position/ScrollPositionContext';
import { RoutePath } from '../../router/Routes';

export const DashboardView = () => {
    const { setScrollPosition } = useScrollPositionContext();
    const vendor = useVendor();
    const queryClient = useQueryClient();

    useEffect(
        () => () => {
            setScrollPosition(RoutePath.DASHBOARD, 0);
            queryClient.removeQueries({ queryKey: [BROWSE_LISTING_KEY] });
        },
        []
    );

    return (
        <SearchResultsContextProvider>
            <DashboardFormContextProvider
                defaultFormData={{
                    ...getDefaultDashboardFormData(),
                    sort: [
                        {
                            property: 'price',
                            direction: SortDirection.ASCENDING,
                        },
                    ],
                    materialType: vendor === 'TNA' ? MaterialType.CARBON_STEEL : MaterialType.MILD_STEEL,
                }}
            >
                <CheckoutContextProvider>
                    <Outlet />
                </CheckoutContextProvider>
            </DashboardFormContextProvider>
        </SearchResultsContextProvider>
    );
};
